var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookIllustration = function SvgFacebookIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#facebookIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.913,
    cy: 30.628,
    fill: "#fff",
    rx: 28.913,
    ry: 27.628
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C5A9A",
    d: "M38.179 17.268h-4.27c-2.534 0-5.353 1.066-5.353 4.739.013 1.28 0 2.505 0 3.885h-2.931v4.664h3.022v13.43H34.2V30.467h3.666l.331-4.59h-4.092s.009-2.04 0-2.634c0-1.451 1.51-1.368 1.6-1.368.72 0 2.117.002 2.476 0v-4.608z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "facebookIllustration_svg__a",
    width: 64.249,
    height: 61.68,
    x: 0.43,
    y: 0.43,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.642,
    dy: 0.642
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.606
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_420_1175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_420_1175",
    result: "shape"
  })))));
};
export default SvgFacebookIllustration;